import React from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { DropDownBox } from '@apply/components';

export const PointOfContactField: React.FC = () => {
    const pointOfContactId = useBrokerDetailsStore((s) => s.pointOfContactId);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const pointsOfContact = useBrokerDetailsStore((s) => s.pointsOfContact);

    return (
        <DropDownBox
            id='pointOfContact'
            value={pointOfContactId}
            onChange={(v) => updateFields({ pointOfContactId: v })}
            label='Point of Contact'
            required
            dataSource={pointsOfContact}
            displayExpr='name'
            valueExpr='key'
            placeholder=''
            width='100%'
        />
    );
};
